function AdmissionGroupReceiptsCtrl($scope) {
  if (!$scope.admissionGroup) throw new Error('close-admission-group directive - admissionGroup is required on scope');

  $scope.addReceipt = function ($event) {
    if ($event) $event.preventDefault();

    $scope.admissionGroup.receipts.push({
      name: '',
      subtotal: 0,
      type: 'PUBLIC'
    });
  };

  $scope.removeReceipt = function (receipt, $event) {
    if (!receipt) return;
    if ($event) $event.preventDefault();

    $scope.admissionGroup.receipts.splice($scope.admissionGroup.receipts.indexOf(receipt), 1);
  };
}

AdmissionGroupReceiptsCtrl.$inject = [
  '$scope'
];

export default AdmissionGroupReceiptsCtrl;



// WEBPACK FOOTER //
// ./src/directives/admissionGroupReceipts/controller.js